// MOBILE MENU
function mmMobileMenu() {
  const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
  mobileMenu.classList.toggle("mm-menu-open");
  menu.classList.toggle("mm-header-open");
  if (mobileMenu.classList.contains("mm-menu-open")) {
      document.querySelector("html").classList.add("stop-scrolling");
      mmRemoveHeaderLight();
  } else {
      document.querySelector("html").classList.remove("stop-scrolling");
  }
}

function mmMobileMenuDropdown(elem, elem2) {
  var elemSelector = document.querySelector(elem);
  var elemSelector2 = document.querySelector(elem2);
  elemSelector.classList.toggle("open");
  elemSelector2.classList.toggle("open");
  document.querySelector("html").classList.toggle("stop-scrolling");
}

function showInfoDarkButton(elemToShowClass) {
  let elemToShow = document.querySelectorAll(elemToShowClass);
  elemToShow.forEach((element) => {
      let darkButton = element.nextElementSibling;
      darkButton.classList.toggle("hidden");
  });
}

// Target blank External (Calendly) menu link
  (function () {
      var links = document.links;
      for (let i = 0, linksLength = links.length; i < linksLength; i++) {
          if (links[i].hostname !== window.location.hostname) {
              links[i].target = '_blank';
              links[i].rel = 'noreferrer noopener';
          }
      }
  })();
